import { render, staticRenderFns } from "./EnergyDetailTab.vue?vue&type=template&id=623aa9b2&scoped=true"
import script from "./EnergyDetailTab.vue?vue&type=script&lang=js"
export * from "./EnergyDetailTab.vue?vue&type=script&lang=js"
import style0 from "./EnergyDetailTab.vue?vue&type=style&index=0&id=623aa9b2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623aa9b2",
  null
  
)

export default component.exports